module.exports = __webpack_public_path__ + "img/center-intro-structure3-1.c33a3f6a.png";